/**
 * GA4 event helper. Sends events with consistent page context when gtag is available.
 * Use for product usage events (copy_forwarding_address, view_digest_details, etc.).
 * Events only fire in production where _GoogleAnalytics partial loads gtag.
 */
export function trackEvent(eventName, eventParams) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    var params = {
        page_path: window.location.pathname + window.location.search,
        page_title: typeof document !== "undefined" ? document.title : ""
    };
    if (eventParams && typeof eventParams === "object") {
        for (var k in eventParams) {
            if (Object.prototype.hasOwnProperty.call(eventParams, k)) {
                params[k] = eventParams[k];
            }
        }
    }
    window.gtag("event", eventName, params);
}
